import React, { Component } from 'react';
import Button from '../Components/Button.js';
import MaterialIcon from 'material-icons-react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import './ShareRoomPopup.css';

export default class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      copyLinkButtonText: 'Copy Link'
    }
    this.selectRoomNameURL = this.selectRoomNameURL.bind(this);
  }

  componentDidUpdate() {
    if (this.props.show) {
      this.roomNameURLInput.select();
    }
  }

  selectRoomNameURL() {
    this.roomNameURLInput.select()
  }

  render() {
    if (this.props.show) {
      return (
        <div className="popup">
          <div className="popup-mask" onClick={this.props.toggleShareRoomPopup}></div>
          <div className="popup-content">
            <div className="popup-close" onClick={this.props.toggleShareRoomPopup}><MaterialIcon icon="cancel" /></div>
            <div className="popup-title">Share this room <span role="img" aria-label="woman with computer">👩‍💻</span><span role="img" aria-label="man with computer">👨‍💻</span></div>
            <div className="popup-description">Let other people connect, copy this link!</div>
            <div className="input-button-combo">
              <input type="text" readOnly
                onClick={this.selectRoomNameURL}
                value={this.props.roomNameURL}
                ref={(input) => { this.roomNameURLInput = input; }} />

              <CopyToClipboard text={this.props.roomNameURL}
                 onCopy={() => this.setState({copyLinkButtonText: 'Copied!'})}>
                <Button className="button--green">{this.state.copyLinkButtonText}</Button>
              </CopyToClipboard>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/Room/ShareRoomPopup.js